import { useState, useEffect } from 'react';

const navItems = [
  { label: '사명', href: '#mission' },
  { label: '장애인 이야기', href: '#stories' },
  { label: '상담 지원', href: '#counseling' },
  { label: '교육 프로그램', href: '#education' },
  { label: '뉴스 & 정보', href: '#news' },
  { label: '후원하기', href: '#donation' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 h-16 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2">
          <div className="w-9 h-9 flex items-center justify-center bg-amber-600 rounded-lg">
            <i className="ri-heart-2-fill text-white text-base"></i>
          </div>
          <span className={`font-bold text-2xl tracking-tight ${scrolled ? 'text-stone-800' : 'text-white'}`}>
            대한효복지센터
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNav(e, item.href)}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                scrolled
                  ? 'text-stone-600 hover:text-amber-700'
                  : 'text-white/90 hover:text-white'
              }`}
            >
              {item.label}
            </a>
          ))}
          <a
            href="#donation"
            onClick={(e) => handleNav(e, '#donation')}
            className="px-5 py-2 rounded-full text-sm font-semibold bg-amber-600 text-white hover:bg-amber-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            지금 후원
          </a>
        </nav>

        <button
          className={`lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${scrolled ? 'text-stone-700' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="메뉴"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="lg:hidden bg-white/98 backdrop-blur-md border-t border-stone-100 px-8 py-4">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleNav(e, item.href)}
              className="block py-3 text-stone-700 font-medium text-sm border-b border-stone-100 last:border-0 cursor-pointer"
            >
              {item.label}
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
